
import * as React from "react";
import * as ReactDOM from "react-dom";
import SearchBoxDemo from "./SearchBoxDemo";

ReactDOM.render(
    React.createElement(SearchBoxDemo),
    document.getElementById("root")
);
